module.exports=function(scope){ return `<!-- enrollmentIdentifier found in database -->
{
    "meta": {
        "ok": true,
        "code": 200,
        "message": "The entry in the database for this enrollmentIdentifier was successfully deleted."
    },
    "data": {}
}

<!-- enrollmentIdentifier not found in database -->
{
    "meta": {
        "ok": true,
        "code": 200,
        "message": "No entry found in the database for this enrollmentIdentifier."
    },
    "data": {}
}
`};


// WEBPACK FOOTER //
// ./src/resources/code/restsdk-v2/response/success/enrollment-delete.json.tpl